import React, { memo } from "react";
import { Box } from "@mui/material";
import ActivitiesIcon from "../../../components/VectorIcons/ActivitiesIcon";

const ACTIVITY_BADGE_SX = {
  width: "16px",
  height: "16px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#7070b3",
  color: "#fff !important",
  position: "absolute",
  bottom: "-5px",
  right: "-5px",
  borderRadius: "100%",
  fontSize: "10px",
  fontFamily: '"Globotipo Text Bold", sans-serif',
  paddingTop: "1px",
  paddingLeft: "2px",
};

const ActivityBadge = memo(({ activityCount }) => (
  <Box sx={{ position: "relative" }}>
    <Box sx={ACTIVITY_BADGE_SX}>{activityCount ?? 0}</Box>
    <ActivitiesIcon color="#7070B3" />
  </Box>
));

export default ActivityBadge;
